<div>
    <div *ngIf="survey">
        <img *ngIf="survey.surveyLogoPath" src="{{ survey.surveyLogoPath }}" alt="Logo" class="logo">
        <h2>{{'Thank you for taking part in the'}} {{ survey.surveyName }}</h2>
    </div>

    <div *ngIf="!survey">
        <img src="/assets/images/nhsbn-mark.png" alt="Logo" class="logo">
        <h2>{{'Thank you for taking part in the survey'}}</h2>
    </div>

    <!-- Custom outro wording --> 
    <p *ngIf="survey && survey.surveyOutro" [innerHTML]="surveyOutro"></p>

    <div class="mt-2">
        <p>You can now close this browser tab.</p>
    </div>
</div>